export default __webpack_public_path__ + "static/media/tanishq10gm.dce0db7bcc109de9f0c021bf2a362792.png";